import type {
  AlgorithmParamsKeys,
  AlgorithmTypes,
  Calculation,
  FormDataML,
  MLModalNavItemType,
} from '@core/core/types'
import type { FC } from 'react'

import { getNextCalculation } from '../constants'
import { Algorithm } from './Alghoritm'
import { Calculations } from './Calculations'

type RightMenuProps = {
  item: MLModalNavItemType
  formData: FormDataML
  handleChange: (formData: FormDataML) => void
  handleTypeChange: (type: AlgorithmTypes) => void
}

export const RightMenu: FC<RightMenuProps> = ({
  item,
  formData,
  handleChange,
  handleTypeChange,
}) => {
  function handleFormChange(field: AlgorithmParamsKeys, value: string | number | boolean) {
    handleChange({
      ...formData,
      algorithm: { ...formData.algorithm, [field]: value },
    })
  }

  const addCalculation = () => {
    const maxId = formData.calculations.at(-1)?.id ?? 0
    handleChange({
      ...formData,
      calculations: [...formData.calculations, getNextCalculation(maxId + 1)],
    })
  }
  const updateCalculation = (calculation: Calculation) => {
    const calculations = formData.calculations.map(calc =>
      calc.id === calculation.id ? calculation : calc,
    )
    handleChange({
      ...formData,
      calculations,
    })
  }
  const deleteCalculation = (id: number) => {
    const calculations = formData.calculations.filter(calc => calc.id !== id)
    handleChange({
      ...formData,
      calculations,
    })
  }

  switch (item) {
    case 'algorithm':
      return (
        <Algorithm
          formData={formData}
          handleChange={handleFormChange}
          handleTypeChange={handleTypeChange}
          resetForm={handleChange}
        />
      )
    case 'calculations':
      return (
        <Calculations
          formData={formData}
          addCalculation={addCalculation}
          updateCalculation={updateCalculation}
          deleteCalculation={deleteCalculation}
        />
      )
  }
}
